import { toast } from 'sonner';
import { useQuery } from '@tanstack/react-query';

import { extractApiErrorDetail } from '@/shared';

import { loadDocumentDrafts } from '../api/documentDraftShelf';
import type { DocumentDraftStore } from './documentDraftStore';

export const documentDraftKeys = {
  all: (store: DocumentDraftStore) => [store.kind] as const,
  patient: (patientId: string, store: DocumentDraftStore) => [store.kind, patientId] as const,
};

export function useDocumentDraftsQuery(patientId: string | undefined, store: DocumentDraftStore) {
  return useQuery({
    queryKey: patientId
      ? documentDraftKeys.patient(patientId, store)
      : documentDraftKeys.all(store),
    queryFn: async () => {
      if (!patientId) {
        throw new Error('A patient ID is required to load drafts.');
      }
      try {
        return await loadDocumentDrafts(patientId, store);
      } catch (error) {
        toast.info('Drafts unavailable', {
          description:
            extractApiErrorDetail(error) ?? 'We could not load drafts. Please try again.',
        });
        throw error;
      }
    },
    enabled: Boolean(patientId),
    retry: false,
    staleTime: 30_000,
    meta: {
      toastOnError: false,
    },
  });
}
